export default __webpack_public_path__ + "static/media/tiktok-blue.8dc9d4f5.svg";